module.exports = __webpack_public_path__ + "img/eth_mainlogo.ac871aa7.svg";